(() => {
  const init = (root) => {
    const swiperEl = root.querySelector('.collection-with-slider__swiper');
    if (!swiperEl) return;
    if (!window.Swiper) return;
    if (swiperEl.dataset.initialized === 'true') return;

    const slidesDesktop = Number(swiperEl.dataset.slidesDesktop || 4);
    const slidesMobile = Number(swiperEl.dataset.slidesMobile || 1.2);

    const prevEl = root.querySelector('.collection-with-slider__btn--prev');
    const nextEl = root.querySelector('.collection-with-slider__btn--next');
    const paginationEl = root.querySelector('.collection-with-slider__pagination');

    // eslint-disable-next-line no-new
    new window.Swiper(swiperEl, {
      slidesPerView: slidesMobile,
      spaceBetween: 19,
      speed: 450,
      watchOverflow: true,
      navigation: {
        prevEl,
        nextEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: slidesDesktop,
          spaceBetween: 20,
        },
      },
    });

    swiperEl.dataset.initialized = 'true';
  };

  const boot = () => {
    document.querySelectorAll('.collection-with-slider').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Shopify Theme Editor support (multiple instances safe)
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target?.querySelector?.('.collection-with-slider') || e.target;
    if (root && root.classList?.contains('collection-with-slider')) init(root);
  });
})();

